import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';
import NextLink from 'next/link';
import LazyLoad from 'react-lazyload';
import CustomButton from 'components/CustomButton';
import { useStyles } from './styles';

const Props = {
  textTitle: PropTypes.node.isRequired,
  textInformation: PropTypes.node.isRequired,
  textButton: PropTypes.string.isRequired,
};

export default function InstitutionsCommunication({ textTitle, textInformation, textButton }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box py={6}>
        <Container>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Image
              src="/images/institutions/leishmania-institutions.webp"
              alt="leishmania institutions"
              loading="lazy"
              width={393}
              height={358}
            />

            <Box ml={8}>
              <Typography className={classes.primaryColor} variant="h4" component="h2">
                <b>{textTitle}</b>
              </Typography>

              <Box pt={2} pb={6}>
                <Typography className={classes.textInformation} variant="h6" component="p">
                  {textInformation}
                </Typography>
              </Box>

              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton>{textButton}</CustomButton>
              </NextLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}

InstitutionsCommunication.propTypes = Props;
